import React from 'react';
import PropTypes from 'prop-types';

const FormInputEmail = (props) => {
  const {
    name, label, placeholder, value, onChange, error,
  } = props;

  const onBlur = (event) => {
    const { target } = event;
    onChange(target.name, target.value.replace(/\s/g, ''));
  };

  return (
    <div>
      <label
        className={error ? 'leadForm__label leadForm__label--error' : 'leadForm__label'}
      >
        {label
          && (
          <span
            className={error ? 'leadForm__label-text leadForm__label-text--error' : 'leadForm__label-text'}
          >
            {label}
          </span>
          )}
        <input
          className={error ? 'leadForm__input leadForm__input--error' : 'leadForm__input'}
          name={name}
          type="email"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.name, event.target.value)}
          onBlur={onBlur}
        />
      </label>
      {
        error && <span className="leadForm__fieldError">{error}</span>
      }
    </div>
  );
};

FormInputEmail.defaultProps = {
  error: null,
  label: null,
};

FormInputEmail.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default FormInputEmail;
